import { useContext, useEffect, useState } from 'react';
import login from '@/api/auth/login.endpoint';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useRouter } from 'next/router';
import setAuthenticatedUser from 'src/modules/auth/setAuthenticatedUser';
import { StudentContext } from '@/shared/StudentContext/StudentContext';

export default function useSuccessStep({ flowState }) {
  const context = useContext(GlobalContext);
  const studentContext = useContext(StudentContext);
  const router = useRouter();
  const [state, setState] = useState({
    loading: true,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    login: async () => {
      try {
        const response = await login({
          login: flowState.credentials.username,
          password: flowState.credentials.password,
        });
        await setAuthenticatedUser({
          accessToken: response.token,
          context,
        });
      } catch (e) {
        actions.setState({
          loading: false,
        });
      }
    },
    goToDashboard: () => {
      router.push('/student/dashboard');
    },
  };

  useEffect(() => {
    if (!context.state.user) {
      actions.login();
    } else {
      studentContext.actions.forceClassesReload();
      actions.setState({
        loading: false,
      });
    }
  }, [context.state]);

  return { state, actions };
}
